function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { ConfigContext } from './ConfigContext';
import { constants } from '../constants';
import { Close as CloseIcon } from '@mui/icons-material';
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, Divider, FormControl, IconButton, InputLabel, MenuItem, Select, Switch, TextField, Typography } from '@mui/material';
// Helper function to validate resource actions from form state
var getValidResourceActionsFromForm = function getValidResourceActionsFromForm(resourceActions) {
    return resourceActions.filter(function (ra) {
        return ra.resource.trim() && ra.actions.length > 0;
    }).map(function (ra) {
        return {
            action: ra.actions,
            applicationresource_id: [ra.resource]
        };
    });
};
// Helper function to create policy data from JSON
var createPolicyDataFromJson = function createPolicyDataFromJson(parsedJsonData, validResourceActions, jsonString, policy, isEditMode) {
    var _parsedJsonData$appli, _policy$dateAdded;
    // Extract application_id from parsed JSON, handling various formats
    var applicationId = (_parsedJsonData$appli = parsedJsonData.application_id) !== null && _parsedJsonData$appli !== void 0 ? _parsedJsonData$appli : policy === null || policy === void 0 ? void 0 : policy.application_id;
    // No unreachable return, just assign and use
    return _objectSpread(_objectSpread({}, isEditMode && (policy === null || policy === void 0 ? void 0 : policy.id) && {
        id: policy.id
    }), {}, {
        name: parsedJsonData.name.trim(),
        effect: parsedJsonData.effect.toLowerCase(),
        resource_action: validResourceActions,
        application_id: applicationId,
        specification: jsonString,
        dateAdded: (_policy$dateAdded = policy === null || policy === void 0 ? void 0 : policy.dateAdded) !== null && _policy$dateAdded !== void 0 ? _policy$dateAdded : new Date().toLocaleDateString()
    });
};
// Helper function to create policy data from form state
var createPolicyDataFromForm = function createPolicyDataFromForm(policyName, effect, validResourceActions, applicationIds, policy, isEditMode) {
    var _policy$dateAdded2;
    // Handle 'none' option - convert to empty array to indicate no application
    var applicationId;
    if (applicationIds.includes('none')) {
        applicationId = [];
    }
    else if (applicationIds.length > 0) {
        applicationId = applicationIds;
    }
    else {
        applicationId = policy === null || policy === void 0 ? void 0 : policy.application_id;
    }
    return _objectSpread(_objectSpread({}, isEditMode && (policy === null || policy === void 0 ? void 0 : policy.id) && {
        id: policy.id
    }), {}, {
        name: policyName.trim(),
        effect: effect.toLowerCase(),
        resource_action: validResourceActions,
        application_id: applicationId,
        specification: JSON.stringify({
            resourceType: 'Policy',
            id: isEditMode ? policy === null || policy === void 0 ? void 0 : policy.id : undefined,
            application_id: applicationId || 1,
            name: policyName.trim(),
            effect: effect.toLowerCase(),
            resource_action: validResourceActions,
            details: {},
            metadata: {
                versionId: 1,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                createdBy: '',
                updatedBy: ''
            }
        }, null, 2),
        dateAdded: (_policy$dateAdded2 = policy === null || policy === void 0 ? void 0 : policy.dateAdded) !== null && _policy$dateAdded2 !== void 0 ? _policy$dateAdded2 : new Date().toLocaleDateString()
    });
};
// Helper function to normalize effect value
var normalizeEffectValue = function normalizeEffectValue(effect) {
    if (!effect)
        return 'Allow';
    return effect.toLowerCase() === 'allow' ? 'Allow' : 'Deny';
};
// Helper function to get application IDs from policy
var getApplicationIdsFromPolicy = function getApplicationIdsFromPolicy(applicationId) {
    if (!applicationId)
        return ['none'];
    var appIds = Array.isArray(applicationId) ? applicationId : [applicationId];
    var hasNoApp = appIds.every(function (id) {
        return id === null || id === undefined || id === 'null';
    });
    return hasNoApp ? ['none'] : appIds;
};
// Helper function to parse resource actions from policy
var parseResourceActionsFromPolicy = function parseResourceActionsFromPolicy(resourceAction) {
    var defaultPair = {
        id: '1',
        resource: '',
        actions: []
    };
    if (!resourceAction || !Array.isArray(resourceAction))
        return [defaultPair];
    var pairs = resourceAction.map(function (ra, index) {
        var _ref, _ref2, _ra$applicationresour, _ra$applicationresour2, _ra$application_resou, _ra$resource, _ra$action;
        return {
            id: (index + 1).toString(),
            resource: (_ref = (_ref2 = (_ra$applicationresour = (_ra$applicationresour2 = ra.applicationresource_id) === null || _ra$applicationresour2 === void 0 ? void 0 : _ra$applicationresour2[0]) !== null && _ra$applicationresour !== void 0 ? _ra$applicationresour : (_ra$application_resou = ra.application_resource) === null || _ra$application_resou === void 0 ? void 0 : _ra$application_resou[0]) !== null && _ref2 !== void 0 ? _ref2 : (_ra$resource = ra.resource) === null || _ra$resource === void 0 ? void 0 : _ra$resource[0]) !== null && _ref !== void 0 ? _ref : '',
            actions: (_ra$action = ra.action) !== null && _ra$action !== void 0 ? _ra$action : []
        };
    });
    return pairs.length > 0 ? pairs : [defaultPair];
};
// Default resource action pair
var getDefaultResourceActions = function getDefaultResourceActions() {
    return [{
            id: '1',
            resource: '',
            actions: []
        }];
};
var PolicyModal = function PolicyModal(_ref3) {
    var _configState$settings, _configState$settings2, _configState$settings3, _configState$settings4;
    var open = _ref3.open, onClose = _ref3.onClose, onSave = _ref3.onSave, policy = _ref3.policy, loading = _ref3.loading, _ref3$applications = _ref3.applications, applications = _ref3$applications === void 0 ? [] : _ref3$applications;
    var _useState = useState(''), _useState2 = _slicedToArray(_useState, 2), policyName = _useState2[0], setPolicyName = _useState2[1];
    var _useState3 = useState([{
            id: '1',
            resource: '',
            actions: []
        }]), _useState4 = _slicedToArray(_useState3, 2), resourceActions = _useState4[0], setResourceActions = _useState4[1];
    var _useState5 = useState('Allow'), _useState6 = _slicedToArray(_useState5, 2), effect = _useState6[0], setEffect = _useState6[1];
    var _useState7 = useState([]), _useState8 = _slicedToArray(_useState7, 2), applicationIds = _useState8[0], setApplicationIds = _useState8[1];
    var _useState9 = useState(null), _useState0 = _slicedToArray(_useState9, 2), error = _useState0[0], setError = _useState0[1];
    var _useState1 = useState('preview'), _useState10 = _slicedToArray(_useState1, 2), jsonMode = _useState10[0], setJsonMode = _useState10[1];
    var _useState11 = useState(''), _useState12 = _slicedToArray(_useState11, 2), jsonString = _useState12[0], setJsonString = _useState12[1];
    var _useState13 = useState(null), _useState14 = _slicedToArray(_useState13, 2), jsonError = _useState14[0], setJsonError = _useState14[1];
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState;
    var isEditMode = !!policy;
    // Function to generate JSON from current form state
    var generateJsonFromForm = function generateJsonFromForm() {
        var validResourceActions = resourceActions.filter(function (ra) {
            return ra.resource && ra.actions.length > 0;
        });
        // Handle 'none' option - show empty array in JSON preview
        var appIdsForJson = [];
        if (applicationIds.includes('none')) {
            appIdsForJson = [];
        }
        else if (applicationIds.length > 0) {
            appIdsForJson = applicationIds;
        }
        else {
            appIdsForJson = [''];
        }
        return JSON.stringify({
            resourceType: 'Policy',
            id: isEditMode ? policy === null || policy === void 0 ? void 0 : policy.id : undefined,
            application_id: appIdsForJson,
            name: policyName,
            effect: effect.toLowerCase(),
            resource_action: validResourceActions.map(function (ra) {
                return {
                    action: ra.actions,
                    applicationresource_id: [ra.resource]
                };
            }),
            details: {},
            metadata: {
                versionId: 1,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                createdBy: '',
                updatedBy: ''
            }
        }, null, 2);
    };
    // Function to sync form from JSON
    var syncFormFromJson = function syncFormFromJson(jsonText) {
        try {
            var parsed = JSON.parse(jsonText);
            // Update form fields
            if (parsed.name)
                setPolicyName(parsed.name);
            if (parsed.effect) {
                // Handle both lowercase and title case values
                var effectValue = parsed.effect.toLowerCase();
                var newEffect = '';
                if (effectValue === 'allow') {
                    newEffect = 'Allow';
                }
                else if (effectValue === 'deny') {
                    newEffect = 'Deny';
                }
                setEffect(newEffect);
            }
            // Update application_id
            if (parsed.application_id !== undefined) {
                var appIds = Array.isArray(parsed.application_id) ? parsed.application_id : [parsed.application_id];
                setApplicationIds(appIds);
            }
            // Update resource actions
            if (parsed.resource_action && Array.isArray(parsed.resource_action)) {
                var newResourceActions = parsed.resource_action.map(function (ra, index) {
                    var _ref4, _ra$applicationresour3, _ra$applicationresour4, _ra$resource2, _ra$action2;
                    return {
                        id: (index + 1).toString(),
                        resource: (_ref4 = (_ra$applicationresour3 = (_ra$applicationresour4 = ra.applicationresource_id) === null || _ra$applicationresour4 === void 0 ? void 0 : _ra$applicationresour4[0]) !== null && _ra$applicationresour3 !== void 0 ? _ra$applicationresour3 : (_ra$resource2 = ra.resource) === null || _ra$resource2 === void 0 ? void 0 : _ra$resource2[0]) !== null && _ref4 !== void 0 ? _ref4 : '',
                        actions: (_ra$action2 = ra.action) !== null && _ra$action2 !== void 0 ? _ra$action2 : []
                    };
                });
                setResourceActions(newResourceActions.length > 0 ? newResourceActions : [{
                        id: '1',
                        resource: '',
                        actions: []
                    }]);
            }
            setJsonError(null);
            return true;
        }
        catch (_unused) {
            setJsonError(constants.configuration_modal_error_json_invalid);
            return false;
        }
    };
    // Handle JSON mode toggle
    var handleJsonModeToggle = function handleJsonModeToggle() {
        if (jsonMode === 'preview') {
            // Switching to edit mode - populate with current form state
            setJsonString(generateJsonFromForm());
            setJsonMode('edit');
        }
        else if (syncFormFromJson(jsonString)) {
            // Switching to preview mode - sync form with JSON successful
            setJsonMode('preview');
        }
        // If sync failed, stay in edit mode to fix errors
    };
    // Handle JSON text change
    var handleJsonChange = function handleJsonChange(newJsonText) {
        setJsonString(newJsonText);
        setJsonError(null);
    };
    // Handle application selection change
    var handleAppChange = function handleAppChange(event) {
        var value = event.target.value;
        var newValue = typeof value === 'string' ? value.split(',') : value;
        // If 'none' is selected, clear other selections; if other is selected, remove 'none'
        if (newValue.includes('none') && !applicationIds.map(String).includes('none')) {
            setApplicationIds(['none']);
        }
        else if (newValue.includes('none') && newValue.length > 1) {
            setApplicationIds(newValue.filter(function (id) {
                return id !== 'none';
            }));
        }
        else {
            setApplicationIds(newValue);
        }
    };
    useEffect(function () {
        if (policy) {
            setPolicyName(policy.name || '');
            setEffect(normalizeEffectValue(policy.effect));
            setApplicationIds(getApplicationIdsFromPolicy(policy.application_id));
            setResourceActions(parseResourceActionsFromPolicy(policy.resource_action));
        }
        else {
            // Reset for new policy
            setPolicyName('');
            setEffect('Allow');
            setApplicationIds([]);
            setResourceActions(getDefaultResourceActions());
        }
        setError(null);
        setJsonMode('preview');
        setJsonError(null);
        // JSON string will be generated in preview mode
    }, [policy, open]);
    var handleSave = function handleSave() {
        var _parsedJsonData$name, _parsedJsonData, _parsedJsonData2;
        var parsedJsonData = null;
        // Validate JSON mode if in edit mode
        if (jsonMode === 'edit') {
            try {
                parsedJsonData = JSON.parse(jsonString);
                if (!syncFormFromJson(jsonString)) {
                    return;
                }
            }
            catch (_unused2) {
                setJsonError(constants.configuration_modal_error_json_invalid);
                return;
            }
        }
        // Validate policy name
        var nameToValidate = (_parsedJsonData$name = (_parsedJsonData = parsedJsonData) === null || _parsedJsonData === void 0 ? void 0 : _parsedJsonData.name) !== null && _parsedJsonData$name !== void 0 ? _parsedJsonData$name : policyName;
        if (!(nameToValidate !== null && nameToValidate !== void 0 && nameToValidate.trim())) {
            setError(constants.policy_modal_error_name_required);
            return;
        }
        // Get validated resource actions
        var validResourceActions = (_parsedJsonData2 = parsedJsonData) !== null && _parsedJsonData2 !== void 0 && _parsedJsonData2.resource_action ? parsedJsonData.resource_action.filter(function (ra) {
            var _ra$applicationresour5, _ra$action3;
            return ((_ra$applicationresour5 = ra.applicationresource_id) === null || _ra$applicationresour5 === void 0 ? void 0 : _ra$applicationresour5[0]) && ((_ra$action3 = ra.action) === null || _ra$action3 === void 0 ? void 0 : _ra$action3.length) > 0;
        }).map(function (ra) {
            return {
                action: ra.action,
                applicationresource_id: ra.applicationresource_id
            };
        }) : getValidResourceActionsFromForm(resourceActions);
        if (validResourceActions.length === 0) {
            setError(constants.policy_modal_error_resource_action_required);
            return;
        }
        // Create policy data based on mode
        var policyData = parsedJsonData && jsonMode === 'edit' ? createPolicyDataFromJson(parsedJsonData, validResourceActions, jsonString, policy, isEditMode) : createPolicyDataFromForm(policyName, effect, validResourceActions, applicationIds, policy, isEditMode);
        onSave(policyData);
    };
    // For new policies, require at least one application to be selected
    var canSave = policyName.trim() && !loading && (isEditMode || applicationIds.length > 0);
    var getButtonText = function getButtonText() {
        if (loading) {
            return constants.saving;
        }
        return isEditMode ? constants.configuration_modal_button_update : constants.configuration_modal_button_add;
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        maxWidth: "lg",
        fullWidth: true,
        PaperProps: {
            sx: {
                borderRadius: 2,
                boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.1)',
                height: '90vh',
                maxHeight: '700px'
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 1.5,
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            color: '#212121',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: '20px'
        }
    }, isEditMode ? constants.policy_modal_title_edit((_configState$settings = configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.workspace_name) !== null && _configState$settings !== void 0 ? _configState$settings : constants.workspace_default_name) : constants.policy_modal_title_add((_configState$settings3 = configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.workspace_name) !== null && _configState$settings3 !== void 0 ? _configState$settings3 : constants.workspace_default_name)), /*#__PURE__*/ React.createElement(IconButton, {
        onClick: onClose,
        sx: {
            color: '#595959'
        }
    }, /*#__PURE__*/ React.createElement(CloseIcon, null))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flex: 1,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: '400px',
            p: 3,
            borderRight: '1px solid #ebebeb',
            overflow: 'auto'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5
        }
    }, /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        size: "small",
        label: constants.policy_modal_field_name,
        value: policyName,
        onChange: function onChange(e) {
            return setPolicyName(e.target.value);
        },
        required: true
    }), /*#__PURE__*/ React.createElement(FormControl, {
        fullWidth: true,
        size: "small"
    }, /*#__PURE__*/ React.createElement(InputLabel, null, constants.policy_mgmt_application_label), /*#__PURE__*/ React.createElement(Select, {
        multiple: true,
        value: applicationIds.map(String),
        onChange: handleAppChange,
        label: constants.policy_mgmt_application_label,
        renderValue: function renderValue(selected) {
            if (selected.includes('none')) {
                return constants.global_policies;
            }
            return applications.filter(function (app) {
                return selected.includes(String(app.id));
            }).map(function (app) {
                return app.name;
            }).join(', ');
        }
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        value: "none"
    }, constants.global_policies), applications.map(function (app) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: app.id,
            value: String(app.id)
        }, app.name);
    }))), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            borderColor: '#ebebeb'
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: '#212121',
            fontSize: '14px',
            fontFamily: 'Open Sans'
        }
    }, constants.policy_modal_deny), /*#__PURE__*/ React.createElement(Switch, {
        checked: effect === 'Allow',
        onChange: function onChange(e) {
            return setEffect(e.target.checked ? 'Allow' : 'Deny');
        },
        size: "small",
        sx: {
            '& .MuiSwitch-switchBase.Mui-checked': {
                color: '#26890d',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#26890d',
                    opacity: 0.3
                }
            }
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: '#212121',
            fontSize: '14px',
            fontFamily: 'Open Sans'
        }
    }, constants.policy_modal_allow)), error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error"
    }, error))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 2,
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            color: '#212121',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: '16px'
        }
    }, jsonMode === 'edit' ? constants.policy_modal_json_editor_label : constants.policy_modal_json_preview_label), /*#__PURE__*/ React.createElement(Button, {
        variant: jsonMode === 'edit' ? 'contained' : 'outlined',
        size: "small",
        onClick: handleJsonModeToggle,
        sx: {
            textTransform: 'none',
            borderColor: '#26890d',
            color: jsonMode === 'edit' ? '#ffffff' : '#26890d',
            backgroundColor: jsonMode === 'edit' ? '#26890d' : 'transparent',
            fontSize: '14px',
            fontWeight: 600,
            '&:hover': {
                borderColor: '#26890d',
                backgroundColor: jsonMode === 'edit' ? '#1f6b0a' : 'rgba(38, 137, 13, 0.04)'
            }
        }
    }, jsonMode === 'edit' ? constants.policy_modal_switch_to_preview : constants.policy_modal_edit_json)), jsonError && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mx: 3,
            mt: 2
        }
    }, jsonError), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: 1,
            display: 'flex',
            overflow: 'hidden'
        }
    }, jsonMode === 'preview' ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: '32px',
            backgroundColor: '#ffffff',
            p: 1,
            borderRight: '1px solid #f0f0f0',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        component: "pre",
        sx: {
            color: '#212121',
            fontSize: '14px',
            fontFamily: 'Open Sans',
            lineHeight: 1.62,
            margin: 0
        }
    }, Array.from({
        length: 30
    }, function (_, i) {
        return "".concat(i + 1, "\n");
    }).join(''))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: 1,
            backgroundColor: '#f8f8f8',
            p: 2,
            overflow: 'auto'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        component: "pre",
        sx: {
            color: '#000000',
            fontSize: '14px',
            fontFamily: 'Open Sans',
            lineHeight: 1.62,
            margin: 0,
            whiteSpace: 'pre-wrap'
        }
    }, function () {
        // Only show JSON if policy name is provided or it's edit mode
        if (!policyName.trim() && !isEditMode) {
            return '';
        }
        return generateJsonFromForm();
    }()))) :
        /*#__PURE__*/
        /* JSON Editor */
        React.createElement(Box, {
            sx: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 2,
                py: 1,
                backgroundColor: '#f5f5f5',
                borderBottom: '1px solid #e0e0e0'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            sx: {
                color: '#666',
                fontSize: '12px'
            }
        }, constants.policy_modal_json_editor_tip), /*#__PURE__*/ React.createElement(Button, {
            size: "small",
            onClick: function onClick() {
                return setJsonString(generateJsonFromForm());
            },
            sx: {
                textTransform: 'none',
                color: '#26890d',
                fontSize: '12px'
            }
        }, constants.policy_modal_reset_from_form)), /*#__PURE__*/ React.createElement(TextField, {
            multiline: true,
            fullWidth: true,
            value: jsonString,
            onChange: function onChange(e) {
                return handleJsonChange(e.target.value);
            },
            placeholder: constants.policy_modal_json_placeholder,
            variant: "outlined",
            sx: {
                flex: 1,
                '& .MuiOutlinedInput-root': {
                    height: '100%',
                    alignItems: 'flex-start',
                    fontFamily: 'monospace',
                    fontSize: '14px',
                    lineHeight: 1.62,
                    borderRadius: 0,
                    border: 'none',
                    '& fieldset': {
                        border: 'none'
                    }
                },
                '& .MuiInputBase-input': {
                    height: '100% !important',
                    overflow: 'auto !important',
                    resize: 'none',
                    padding: '16px'
                }
            }
        }))))), /*#__PURE__*/ React.createElement(DialogActions, {
        sx: {
            p: '16px 24px',
            gap: 1,
            borderTop: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: onClose,
        variant: "outlined",
        sx: {
            textTransform: 'none',
            borderColor: '#d9d9d9',
            color: '#26890d',
            fontSize: '16px',
            fontWeight: 600,
            fontFamily: 'Open Sans',
            '&:hover': {
                borderColor: '#26890d',
                backgroundColor: 'transparent'
            }
        }
    }, constants.cancel), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleSave,
        variant: "contained",
        disabled: !canSave,
        sx: {
            textTransform: 'none',
            backgroundColor: '#26890d',
            color: '#ffffff',
            fontSize: '16px',
            fontWeight: 600,
            fontFamily: 'Open Sans',
            '&:hover': {
                backgroundColor: '#1f6b0a'
            },
            '&:disabled': {
                backgroundColor: '#d9d9d9',
                color: '#999'
            }
        }
    }, loading ? /*#__PURE__*/ React.createElement(CircularProgress, {
        size: 20,
        color: "inherit"
    }) : getButtonText())));
};
export default PolicyModal;
